import React from 'react';
import classNames from 'classnames';
import './index.less';
import { message } from 'antd';
import { baiduTrackEvent } from 'shared/utils/commonUtil';

class LoanCalc extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loanAmount: undefined,
      loanPeriod: 0,
      paybackPerMonth: 0,
      // 首次计算后，保持结果框不再消失
      hasCalc: false,
      loanAmountPlaceHolder: '请选择您的贷款金额',
    };
    this.loanPerodsChange = this.loanPerodsChange.bind(this);
    this.doCalc = this.doCalc.bind(this);
  }

  loanAmountsChange(amount) {
    if (amount <= 0) {
      this.setState({ loanAmount: '' });
    } else {
      this.setState({ loanAmount: amount });
    }
  }

  loanPerodsChange(period) {
    this.setState({ loanPeriod: period });
  }

  handleChange(event) {
    let val = event.target.value;
    if (isNaN(val)) {
      return false;
    } else if (val.length > 7) {
      // 最多 7 位
      return false;
    } else {
      this.setState({ loanAmount: event.target.value });
    }
  }

  // [贷款本金 × 月利率 ×（1+月利率）^ 还款月数] / [(1+月利率）^ 还款月数) - 1]
  _doCalc(amount = 0, periodByMonth = 1) {
    const RATE_BY_MONTH = 0.72 / 100;

    if (amount <= 0) {
      return 0;
    }

    let rateByMonthPlusOne = RATE_BY_MONTH + 1;
    let a = Math.pow(rateByMonthPlusOne, periodByMonth);
    let dividend = a - 1;
    if (dividend <= 0) {
      // throw new Error('计算还款数分母值非法');
      return 0;
    } else {
      return (amount * RATE_BY_MONTH * a / dividend).toFixed(2);
    }
  }

  doCalc() {
    message.config({
      top: 100,
      duration: 1,
      maxCount: 1,
    });
    if (this.state.loanPeriod === 0) {
      message.error('请选择您的贷款期限');
      return;
    }
    let loanAmount = this.state.loanAmount;
    if (typeof loanAmount === 'undefined' || this.state.loanAmount === 0) {
      message.error('请输入您的贷款金额');
      return;
    }
    baiduTrackEvent('贷款计算器', '点击', '开始计算');

    let paybackPerMonth = this._doCalc(
      this.state.loanAmount,
      this.state.loanPeriod
    );
    this.setState({
      hasCalc: true,
      paybackPerMonth: paybackPerMonth,
    });
  }

  goToTop() {
    baiduTrackEvent('贷款计算器', '点击', '立即申请');
    window.scroll(0, 0);
  }

  render() {
    let calcResult;
    if (this.state.hasCalc) {
      calcResult = (
        <div className="loanCalcResult">
          <span className="loanCalcResultTitle">每月应还:</span>
          <span className="loanCalcResultAmount">
            {this.state.paybackPerMonth}
          </span>{' '}
          <span className="loanCalcResultAmountUnit">元</span>
          <span className="loanCalcResultBtn" onClick={this.goToTop}>
            立即申请
          </span>
        </div>
      );
    } else {
    }

    let isOtherAmount;
    let loanAmount = this.state.loanAmount;
    if (
      typeof loanAmount !== 'undefined' &&
      loanAmount != 20000 &&
      loanAmount != 50000 &&
      loanAmount != 50000 &&
      loanAmount != 100000 &&
      loanAmount != 200000
    ) {
      isOtherAmount = true;
    } else {
      isOtherAmount = false;
    }

    return (
      <div className="LoanCalcForm">
        <div className="loanCalcTitle">算一算，每月还多少</div>

        {calcResult}

        <div className="loanAmounts">
          <div className="loanAmountsTitle">我要贷:</div>
          <div
            className={classNames({
              loanAmountsItem: true,
              loanAmountsItemActive: this.state.loanAmount == 20000,
            })}
            onClick={() => this.loanAmountsChange.bind(this)(20000)}
          >
            2万
          </div>
          <div
            className={classNames({
              loanAmountsItem: true,
              loanAmountsItemActive: this.state.loanAmount == 50000,
            })}
            onClick={() => this.loanAmountsChange.bind(this)(50000)}
          >
            5万
          </div>
          <div
            className={classNames({
              loanAmountsItem: true,
              loanAmountsItemActive: this.state.loanAmount == 100000,
            })}
            onClick={() => this.loanAmountsChange.bind(this)(100000)}
          >
            10万
          </div>
          <div
            className={classNames({
              loanAmountsItem: true,
              loanAmountsItemActive: this.state.loanAmount == 200000,
            })}
            onClick={() => this.loanAmountsChange.bind(this)(200000)}
          >
            20万
          </div>
          <div
            className={classNames({
              loanAmountsItem: true,
              loanAmountsItemActive: isOtherAmount,
            })}
            onClick={() => this.loanAmountsChange(0)}
          >
            其他
          </div>
        </div>
        <input
          className="loanInput"
          placeholder={this.state.loanAmountPlaceHolder}
          type="text"
          value={this.state.loanAmount}
          onChange={this.handleChange.bind(this)}
        />
        <div className="loanPeroids">
          <div className="loanAmountsTitle">贷多久:</div>
          <div
            className={classNames({
              loanPeroidsItem: true,
              loanPeroidsItemActive: this.state.loanPeriod === 3,
            })}
            onClick={() => this.loanPerodsChange(3)}
          >
            3个月
          </div>
          <div
            className={classNames({
              loanPeroidsItem: true,
              loanPeroidsItemActive: this.state.loanPeriod === 6,
            })}
            onClick={() => this.loanPerodsChange(6)}
          >
            6个月
          </div>
          <div
            className={classNames({
              loanPeroidsItem: true,
              loanPeroidsItemActive: this.state.loanPeriod === 9,
            })}
            onClick={() => this.loanPerodsChange(9)}
          >
            9个月
          </div>
          <div
            className={classNames({
              loanPeroidsItem: true,
              loanPeroidsItemActive: this.state.loanPeriod === 12,
            })}
            onClick={() => this.loanPerodsChange(12)}
          >
            12个月
          </div>
          <div
            className={classNames({
              loanPeroidsItem: true,
              loanPeroidsItemActive: this.state.loanPeriod === 24,
            })}
            onClick={() => this.loanPerodsChange(24)}
          >
            24个月
          </div>
        </div>
        <div className="loanCalcFormDoCalcBtn" onClick={this.doCalc}>
          开始计算
        </div>
      </div>
    );
  }
}

export default LoanCalc;



// WEBPACK FOOTER //
// ./src/pages/newHome/components/loanCalc/index.jsx